/**
 * A short confirmation that floats above the thumb zone and clears itself.
 * `role="status"` so a screen reader announces it without stealing focus.
 */
import React, { useEffect } from 'react';
import { CheckIcon } from './Icons';

const TOAST_MS = 4000;

export default function Toast({ message, onDone }) {
  useEffect(() => {
    if (!message) return undefined;
    const timer = setTimeout(() => { if (onDone) onDone(); }, TOAST_MS);
    return () => clearTimeout(timer);
  }, [message, onDone]);

  if (!message) return null;

  return (
    <div className="pp-toast" role="status" aria-live="polite">
      <CheckIcon size={18} width={3} />
      <span>{message}</span>
    </div>
  );
}
